import * as React from "react";
import { connect } from "react-redux";
import { Grid2 as Grid, Select, FormControl, InputLabel, MenuItem, Button } from "@mui/material";
import idssStyle from "../../../Configuration/SharedStyling";
import { Theme, createStyles } from '@mui/material/styles';;
import { withStyles, WithStyles } from '@mui/styles';;
import {
    IGenericUserProps,
    genericMapStateToProps
} from "../../../DataClasses/GenericUser";
import BackNavigation from '../../Shared/BackNavigation';
import { ISurveyVenderSubmissionStatusReportPayload } from "../../../DataClasses/ReportData";
import { AjaxError } from "rxjs/ajax";
import { firstValueFrom } from "rxjs";
import ReportsService from "../../Services/ReportsService";
import { Link, LinkProps } from "react-router-dom";
import SharedMaterialReactTable, { ISharedTableColumn } from "../../Shared/MaterialReactTable";
import SharedUtility from "../../../Utilities/SharedUtility";
import { Redirect } from "react-router-dom";

const styles = (theme: Theme) => createStyles({ ...idssStyle(theme) });

interface ICahpsVendorSubmissionStatusReportState {
    data: any[];
    isLoading: boolean;
    availableMeasurementYears: any[];
    selectedMeasurementYear: number;
    redirect: boolean;
}

const AdapterLink = React.forwardRef<HTMLAnchorElement, LinkProps>(
    (props, ref) => <Link innerRef={ref as any} {...props} />
);

type IStylesProps = WithStyles<typeof styles>;

// VIEW
class CahpsVendorSubmissionStatusReportView extends React.Component<
    IGenericUserProps & IStylesProps,
    ICahpsVendorSubmissionStatusReportState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            data: [],
            isLoading: true,
            availableMeasurementYears: [],
            selectedMeasurementYear: -1,
            redirect: false
        };
    }

    public componentDidMount() {
        this.RefreshModel();
    }

    private redirectToErrorPage() {
        return <Redirect to='/errorpage' />;
    }

    private setRedirectState() {
        this.setState({ redirect: true });
    }

    private subIdBodyTemplate = (rowData: any) => {
        const { classes } = this.props;
        return (
            <Button
                to={"submissionHome/" + rowData.subId + "/" + rowData.component.replace("HEDIS", "DST")}
                className={classes.linkButton}
                component={AdapterLink}
            >
                {rowData.subId}
            </Button>
        );
    };

    private getTableColumns = (): ISharedTableColumn<any>[] => [
        {
            accessorKey: 'subId',
            header: 'Sub ID',
            enableSorting: true,
            enableFiltering: true,
            Cell: ({ row }) => this.subIdBodyTemplate(row.original),
        },
        {
            accessorKey: 'orgId',
            header: 'Org ID',
            enableSorting: true,
            enableFiltering: true,
        },
        {
            accessorKey: 'component',
            header: 'Component',
            enableSorting: true,
            enableFiltering: true,
        },
        {
            accessorKey: 'productLine',
            header: 'ProductLine',
            enableSorting: true,
            enableFiltering: true,
        },
        {
            accessorKey: 'vendor',
            header: 'Vendor',
            enableSorting: true,
            enableFiltering: true,
        },
        {
            accessorKey: 'stage',
            header: 'Stage',
            enableSorting: true,
            enableFiltering: true,
        },
        {
            accessorKey: 'result',
            header: 'Result',
            enableSorting: true,
            enableFiltering: true,
        },
        {
            accessorKey: 'lastUploadedOn',
            header: 'LastUploadedOn',
            enableSorting: true,
            enableFiltering: true,
        },
        {
            accessorKey: 'markedFinal',
            header: 'MarkedFinal',
            enableSorting: true,
            enableFiltering: true,
        },
    ];

    public render() {
        if (this.state.redirect) {
            return this.redirectToErrorPage();
        }

        const { classes } = this.props;
        return (

            <Grid container={true} className={classes.gridRowFlex} spacing={0}>
                <Grid size={12}>
                    <Grid container={true} spacing={2}>
                        <Grid size={12}>
                            <BackNavigation text="Back to Reports" href="/reportspage" />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={12}>
                    <div className={classes.card}>
                        <FormControl className={classes.formControl}>
                            <InputLabel id="measurementYearLb">MeasurementYear</InputLabel>
                            <Select
                                id="measureYearSelect"
                                value={this.state.availableMeasurementYears}
                                onChange={this.handleSelectedMeasurementYearChange}
                                fullWidth={true}
                            >
                                {this.state.availableMeasurementYears.map(m => (
                                    <MenuItem key={m} value={m}>
                                        {m}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <SharedMaterialReactTable
                            data={this.state.data}
                            columns={this.getTableColumns()}
                            title="CAHPS Vendor Submission Status"
                            isLoading={this.state.isLoading}
                            enablePagination={true}
                            enableSorting={true}
                            enableFiltering={true}
                            enableColumnActions={true}
                            enableRowActions={false}
                            initialState={{
                                pagination: { pageIndex: 0, pageSize: 20 },
                            }}
                            muiPaginationProps={{
                                rowsPerPageOptions: [10, 15, 20, 25, 50, 75, 100, 500, 1000],
                            }}
                            emptyMessage="No data found."
                        />
                    </div>
                </Grid>
            </Grid >
        );
    }

    private handleSelectedMeasurementYearChange = async (ev: React.ChangeEvent<HTMLInputElement>) => {
        const measurementYear = parseInt(ev.target.value);
        this.setState({
            selectedMeasurementYear: measurementYear,
            isLoading: true
        });
        await this.LoadReportFor(measurementYear);
        this.setState({ isLoading: false });
    }

    private async RefreshModel() {
        this.setState({ isLoading: true });
        const yearsRetVal: number[] | AjaxError = await firstValueFrom(
            ReportsService.GetAvailableMeasurementYearsCaller$(this.props.user)
        );
        if (yearsRetVal instanceof AjaxError || !yearsRetVal) {
            this.setRedirectState();
        } else {
            this.setState({ availableMeasurementYears: yearsRetVal });
        }
        await this.LoadReportFor(this.state.selectedMeasurementYear);
        this.setState({ isLoading: false });
    }

    private async LoadReportFor(measurementYear: number) {
        const retval: ISurveyVenderSubmissionStatusReportPayload[] | AjaxError = await firstValueFrom(
            ReportsService.GetCahpsSubmissionStatusReportCaller$(this.props.user, measurementYear)
        );
        if (retval instanceof AjaxError || !retval) {
            this.setRedirectState();
        } else {
            this.setState({
                data: retval.map(item => ({
                    subId: item.submissionId,
                    orgId: item.organizationId,
                    component: item.component,
                    productLine: item.productLine,
                    vendor: item.vendorName,
                    stage: SharedUtility.GetStageCleanName(item.status),
                    result: item.result,
                    lastUploadedOn: item.lastUploadedOn,
                    markedFinal: item.markedFinal
                }))
            });
        }
    }
}

// REDUX CONTAINER
const CahpsVendorSubmissionStatusReportPageWithState = connect<IGenericUserProps>(
    genericMapStateToProps
)(CahpsVendorSubmissionStatusReportView);

// STYLES CONTAINER
const CahpsVendorSubmissionStatusReportPage = withStyles(styles)(
    CahpsVendorSubmissionStatusReportPageWithState
);

export default CahpsVendorSubmissionStatusReportPage;
